'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactTransitionGroup = require('react-transition-group');
var isNumber = require('lodash/isNumber');
var hooks_useCombinedRefs = require('../../hooks/useCombinedRefs.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var isNumber__default = /*#__PURE__*/_interopDefault(isNumber);

const DEFAULT_TIMEOUT = 300;
const Fade = react.forwardRef(({ children, timeout = DEFAULT_TIMEOUT, onEntering, onEntered, onExiting, onExited, style, visible = false, testId, unmountOnExit = true, as, ...props }, ref) => {
    const As = as ?? 'div';
    const internalRef = react.useRef(null);
    const combinedRefs = hooks_useCombinedRefs.useCombinedRefs(ref, internalRef);
    const getTransitionDelay = (state) => {
        if (isNumber__default.default(timeout)) {
            return timeout;
        }
        const isEntering = state === 'entering' || state === 'entered';
        return timeout[isEntering ? 'enter' : 'exit'] ?? DEFAULT_TIMEOUT;
    };
    const transitionStyles = {
        entering: { opacity: '1' },
        entered: { opacity: '1' },
        exiting: { opacity: '0' },
        exited: {
            opacity: '0',
            // opaque elements still take up space and therefore can intercept pointer events
            // so we're disabling them when the element is not visible
            pointerEvents: 'none',
        },
        unmounted: { opacity: '0' },
    };
    return (jsxRuntime.jsx(reactTransitionGroup.Transition, { unmountOnExit: unmountOnExit, timeout: timeout, in: visible, nodeRef: internalRef, onEntering: onEntering, onEntered: onEntered, onExiting: onExiting, onExited: onExited, children: (state) => (jsxRuntime.jsx(As, { style: {
                transition: `opacity ${getTransitionDelay(state)}ms ease-in-out`,
                ...transitionStyles[state],
                ...style,
            }, "data-transitioning": 
            // used in tests so we can determine if an element has finished transitioning
            ['entering', 'exiting'].includes(state), "aria-hidden": ['exiting', 'exited'].includes(state), "data-testid": testId, ...props, ref: combinedRefs, children: children })) }));
});
Fade.displayName = 'Fade';

exports.Fade = Fade;
//# sourceMappingURL=Fade.js.map
